import { Navigate, createFileRoute } from "@tanstack/react-router";
import { EmptyState, Page } from "@sx/ui";

import { useMaybeProject } from "../../shell/project";
import { supervisionMoved } from "../../workspaces/fleet/supervision-moved";

/* Supervision was split on 2026-11-02. The people who answer a robot's call for help moved to
 * Teleoperators (`/teleoperators`); watching a deployed robot and choosing what it is watched
 * for moved to the project's Deployments. This one route keeps every old link working: it
 * renders no page of its own, it lands each address in its new home. A project-scoped home
 * goes to the project the person was last in. */
export const Route = createFileRoute("/_console/supervise/$")({
  component: SupervisionMoved,
});

function SupervisionMoved() {
  const { _splat } = Route.useParams();
  const scope = useMaybeProject();
  const home = supervisionMoved(_splat ?? "");
  switch (home.kind) {
    case "queue":
      return <Navigate to="/teleoperators" replace />;
    case "cockpit":
      return <Navigate to="/teleoperators/cockpit/$ticketId" params={{ ticketId: home.ticketId }} replace />;
    default:
      break;
  }
  if (scope?.loading) return <Page />;
  const address = scope?.address;
  if (address === undefined) {
    // No project to land in: the old home lands in the help queue, which needs none.
    if (home.kind === "monitor") return <Navigate to="/teleoperators" replace />;
    return (
      <Page>
        <EmptyState
          compact
          title="Open a project first"
          hint="Live supervision is under each project's Deployments now."
        />
      </Page>
    );
  }
  switch (home.kind) {
    case "monitor":
      return <Navigate to="/p/$org/$project/deploy/stations" params={address} replace />;
    case "station":
      return (
        <Navigate
          to="/p/$org/$project/deploy/stations/$stationId"
          params={{ ...address, stationId: home.stationId }}
          replace
        />
      );
    case "robots":
      return <Navigate to="/p/$org/$project/deploy" params={address} replace />;
  }
}
